import React, { ChangeEventHandler, ReactNode, VFC, ReactElement } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MuiTextField from '@material-ui/core/TextField';
import { SEARCH_COMPONENT_COLOR } from '../constants';

const useStyles = makeStyles({
  root: {
    backgroundColor: 'white',
    borderRadius: '40px',
  },
  inputLabelRoot: {
    color: SEARCH_COMPONENT_COLOR,
  },
  inputLabelFocused: {
    marginLeft: '4px',
    backgroundColor: 'white',
  },
  inputLabelShrink: {
    backgroundColor: 'white',
  },
  inputRoot: {
    border: `${SEARCH_COMPONENT_COLOR} 1px solid`,
    borderRadius: '40px',
  },
  inputNotchedOutline: {
    border: 'none',
  },
  iconRoot: {
    marginRight: '10px',
  },
});

interface Props {
  icon: ReactElement;
  name: string;
  value: string;
  label: ReactNode;
  placeholder: string;
  onChange: ChangeEventHandler;
}
const TextField: VFC<Props> = ({
  icon,
  placeholder,
  name,
  value,
  label,
  onChange,
}: Props) => {
  const {
    root,
    inputLabelRoot,
    inputLabelFocused,
    inputLabelShrink,
    inputRoot,
    inputNotchedOutline,
  } = useStyles();
  return (
    <MuiTextField
      id={name}
      name={name}
      size="small"
      variant="outlined"
      value={value}
      placeholder={placeholder}
      label={
        <>
          {icon}
          {label}
        </>
      }
      onChange={onChange}
      fullWidth
      classes={{ root }}
      InputLabelProps={{
        classes: {
          root: inputLabelRoot,
          focused: inputLabelFocused,
          shrink: inputLabelShrink,
        },
      }}
      InputProps={{
        notched: true,
        classes: { root: inputRoot, notchedOutline: inputNotchedOutline },
      }}
    />
  );
};

export default TextField;
